import React, { useState } from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../SelectValue/FormikControl'
import Button from '../SelectValue/Button'
import { useNavigate } from 'react-router-dom'
import swal from 'sweetalert';
import Loading from '../SelectValue/Loading'
import getServices from '../../Services/get-service'
import Logo from '../../Assets/images/Zlogo.png'
import { toast } from 'react-toastify'

function ForgetPasswordForm() {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const initialValues = {
    email: '',
  }
  const validationSchema = Yup.object({
    email: Yup
      .string()
      .email()
      .required('Please Enter your Email'),
  })
  const onSubmit = values => {
    setLoading(true)
    const { email } = values
    getServices.forgetPassword(email).then(
      (response) => {
        setLoading(false)
        // const status = response.data.statusCode
        if (response.data.statusCode === 200) {
          localStorage.setItem('requestId', response.data.data?.requestId)
          localStorage.setItem('resetToken', response.data.data?.token)
          localStorage.setItem('email', email)

          toast.success('Otp sent to your mail', { autoClose: 1000 })

          navigate('/resetpassword')
        } else {
          toast.error(
            response.data?.description,
            { autoClose: 1000 }
          )
        }
      },
      (error) => {
        setLoading(false);
        const errorMessage =
          error.response?.data?.description ||
          "Server is currently unavailable. Please try again later.";
        return toast.error(errorMessage, { autoClose: 1000 });
      },
    )
    // navigate('/resetpassword')
  }

  return (
    <div className='bg-signin-bg min-h-screen'>
      <div className='grid w-11/12 md:w-8/12 mx-auto min-h-[80vh] py-10 place-items-center p-3 md:p-0'>
        <Loading
          open={loading}
        />
        <div className='shadow-lg bg-white rounded-[16px] p-6 md:p-16 '>
          <img src={Logo} width='152' height='40' className=" " alt=" logo" />
          <p className='pt-7 text-[18px] text-back-color2 mb-5 md:text-[40px] font-[500]'>Forgot your Password?</p>
          <p className=' mb-3 text-[#44474E]'>We'll email/sms you an OTP to reset your password</p>
          <div className='  mt-5'>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {formik => (
                <Form>

                  <FormikControl
                    control='input'
                    type='email'
                    label='Email address'
                    name='email'

                  />
                  <div className=' grid grid-cols-1 mb-5 mt-6'>
                    <Button
                      name='Reset password'
                    />
                  </div>

                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgetPasswordForm